/**
 * Same-day dispatch countdown for the product-page perks bar
 * (`.product__dispatch-bar`, see sections/main-product.liquid /
 * section-main-product.css). Shown on both mobile and desktop. Counts
 * down to a fixed daily cutoff, computed in a fixed timezone (not the
 * shopper's local one) so the cutoff is consistent no matter where the
 * page is viewed from.
 */
(() => {
  const DISPATCH_TIMEZONE = 'Europe/Amsterdam';
  const DISPATCH_CUTOFF_HOUR = 22; // 24h clock

  function amsterdamSecondsSinceMidnight(now) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: DISPATCH_TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(now);

    const get = (type) => Number(parts.find((part) => part.type === type).value);

    return (get('hour') % 24) * 3600 + get('minute') * 60 + get('second');
  }

  function secondsUntilCutoff(now) {
    const cutoffSeconds = DISPATCH_CUTOFF_HOUR * 3600;
    const nowSeconds = amsterdamSecondsSinceMidnight(now);
    const diff = cutoffSeconds - nowSeconds;
    return diff > 0 ? diff : diff + 86400;
  }

  function formatDuration(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const pad = (value) => String(value).padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  function initDispatchCountdown(timerEl) {
    let intervalId = null;

    function tick() {
      timerEl.textContent = formatDuration(secondsUntilCutoff(new Date()));
    }

    function start() {
      if (intervalId) return;
      tick();
      intervalId = window.setInterval(tick, 1000);
    }

    function stop() {
      if (!intervalId) return;
      window.clearInterval(intervalId);
      intervalId = null;
    }

    // Shown on every viewport width now, so just run continuously; only
    // pause the per-second timer while the tab is actually hidden.
    start();

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });
  }

  document.querySelectorAll('[data-dispatch-timer]').forEach(initDispatchCountdown);
})();
